import { Navigate, useParams } from 'react-router-dom';

// Solo practice is gone, but old emails, notifications and shared links still
// point at /skill-builder/:skillId/play. Send them to the skill page instead.
const SkillPlayRedirect = () => {
  const { skillId } = useParams();
  return <Navigate to={`/skill-builder/${skillId}`} replace />;
};

export default SkillPlayRedirect;
